import { createContext } from 'react';

// Default values must be empty, default values are instead added to BaseWrap default props
const BaseContext = createContext({
    googleMapsApiKey: '',
    isStorybook: false,
});

export default BaseContext;
